// extracted by mini-css-extract-plugin
export default {"tabView":"PostComments_tabView__dOnTm","selected":"PostComments_selected__taIZw"};